import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'Apenas confirmás el pago recibís un email con el link de descarga. Todo es 100% digital en formato PDF. Acceso inmediato en menos de 5 minutos, cualquier día, a cualquier hora.'
}, {
  question: '¿Para qué edad es el Megapack Anti Pantalla?',
  answer: 'Está diseñado para niños de 2 a 7 años. Cada tomo tiene actividades ordenadas por nivel de dificultad para que el nene avance a su propio ritmo sin frustrarse.'
}, {
  question: '¿Necesito materiales especiales para usarlo?',
  answer: 'No. Solo necesitás una impresora, hojas A4 y lápices de colores. Todo está optimizado para impresión hogareña normal. Sin gastos extra.'
}, {
  question: '¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos exclusivos están incluidos en ambas opciones sin costo extra. Si elegís el Megapack + Método Desconectado™ además recibís el plan de 7 días, el protocolo anti-berrinche y el sistema de logros.'
}, {
  question: '¿Qué pasa si mi hijo no quiere hacer las actividades?',
  answer: 'Para eso existe el Método Desconectado™. Te damos el protocolo exacto para presentarle las fichas de forma que las elija solo por encima del celular. El secreto está en cómo se las ofrecés la primera vez.'
}, {
  question: '¿Sirve si tengo más de un hijo de distintas edades?',
  answer: 'Perfecto para eso. Los 6 tomos cubren distintos niveles de dificultad. Podés darle a cada hijo las fichas de su nivel y trabajar con los dos al mismo tiempo en la misma mesa.'
}, {
  question: '¿Es editable? ¿Puedo modificarlo?',
  answer: 'El material viene en PDF listo para imprimir. No es editable, pero tampoco lo necesitás. Está diseñado para usar tal como está, sin preparación previa.'
}, {
  question: '¿Qué diferencia tiene con actividades gratuitas de internet?',
  answer: 'Las actividades de internet son sueltas, sin orden ni progresión. El Megapack es un sistema completo con más de 500 páginas ordenadas por nivel, materia y edad. No buscás más nada. Todo está en un solo lugar.'
}, {
  question: '¿Por qué elegir el Megapack + Método Desconectado™?',
  answer: 'Porque el Megapack te da las actividades y el Método Desconectado™ te dice exactamente cómo hacer la transición del celu a las fichas sin berrinches. Son los dos lados del mismo problema resueltos juntos.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días de garantía total sin preguntas. Si abrís los tomos, los imprimís y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-144">
      <div className="mx-auto max-w-3xl" data-id="element-145">

        {/* TÍTULO */}
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-8" data-id="element-146">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-147">
          {faqs.map((faq, i) => <div key={i} className="bg-white transition-colors border border-orange-200 rounded-lg shadow-sm overflow-hidden" data-id="element-148">
              {/* PREGUNTA */}
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-4 py-3 m-0" style={{
            fontFamily: 'inherit'
          }} data-id="element-149">
                <span className="text-sm font-bold text-gray-900" data-id="element-150">
                  ❓ {i + 1} — {faq.question}
                </span>
                <span className={`shrink-0 text-lg text-orange-500 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-151">
                  +
                </span>
              </button>

              {/* RESPUESTA */}
              {openIndex === i && <div className="px-4 pb-4 pt-0" data-id="element-152">
                  <div className="h-px w-full bg-orange-100 mb-3" data-id="element-153" />
                  <p className="text-sm text-gray-600 m-0 leading-relaxed" data-id="element-154">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>

      </div>
    </section>;
}